import {TranslationFunction} from "../../../i18n/i18n";
import {SubmissionAttachmentType, SubmissionStateType} from "../../../client/submission/SubmissionApiClient";
import {CatalogFormatter} from "../../../common/catalog/CatalogFormatter";

export class SubmissionFormatter {
    static formatSubmissionStateType(submissionStateType: SubmissionStateType | null | undefined, t: TranslationFunction): string {
        return CatalogFormatter.formatCatalogValueByCode(submissionStateType, "submissionStateType", t);
    }
    static formatSubmissionAttachmentType(submissionAttachmentType: SubmissionAttachmentType | null | undefined, t: TranslationFunction): string {
        return CatalogFormatter.formatCatalogValueByCode(submissionAttachmentType, "submissionAttachmentType", t);
    }
}
